import { Component, EventEmitter, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Services, Acesso, TipoFormatoAssinaturaEnum } from '../../shared';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { VisualizadorFormGroup } from './visualizador.formgroup'
import { ConsultarTramiteExternoAction, RejeitarAssinaturaTramiteAction, RegistrarAssinaturaDigitalOnlineAction, RegistrarAssinaturaGovBrAction } from '@smdapp/flux/visualizador/visualizador-store';
import { RegistrarTipoAutenticacaoAction} from '../../flux/autenticacao/autenticacao-store';
import { BnFileUploaderComponent, FileUploaderArquivo } from '@bndes/bndes-ux4';
import { ArquivoTramite } from '@smdapp/shared/models/arquivo-tramite';
import { DataObserver } from "@smdlib/statex/@angular";
import { data } from '@smdlib/statex/core';
import { Anexo } from '@smdapp/shared/models/anexo.model';
import { Assinatura } from '@smdapp/shared/models/assinatura.model';
import { TipoAcessoExternoEnum } from '@smdapp/shared/enums/tipo-acesso-externo.enum';
import { TipoSituacaoTramiteEnum } from '@smdapp/shared/enums/tipo-situacao-tramite-enum';
import { AppState } from '@smdapp/flux';
import { TipoSituacaoAssinaturaEnum } from '@smdapp/shared/enums/tipo-situacao-assinatura.enum';
import { VisualizadorService } from '@smdapp/flux/visualizador/visualizador-service';
import { CookieService } from 'ngx-cookie-service';
import { TipoFormatoRecebimentoDocumentoEnum } from '@smdapp/shared/enums/tipo-formato-recebimento-documento';
import { ParametroGovBr } from '@smdapp/shared/models/parametro-gov-br.model';

import { TipoAutenticacaoEnum} from '../../shared/enums/tipo-autenticacao.enum';
import { throws } from 'assert';
import { ErroApp } from '../../shared/models/erro-app.model';
import { TipoAcaoAssinaturaEnum } from '../../shared/enums/tipo-acao-assinatura.enum';
import * as _ from 'lodash';

import { subscribe, unsubscribe } from '../../../libs/statex/core/decorators';


const tipoAutenticacao$ = (state: AppState) => state.tipoAutenticacao;

@Component({
    selector: 'app-visualizador',
    templateUrl: './visualizador.component.html',
    styleUrls: ['./visualizador.component.scss']
})
export class VisualizadorComponent  extends DataObserver  implements OnInit,OnDestroy{


    @data(tipoAutenticacao$)
    tipoAutenticacao: TipoAutenticacaoEnum;

    justificativaPreenchida: boolean;

    listaTipoAcaoAssinaturaEnum = TipoAcaoAssinaturaEnum;


    @ViewChild('arquivoOriginal', { static: true })
    _arquivoOriginalFileUploaderComponent: BnFileUploaderComponent;

    @ViewChild('arquivoAssinado', { static: true })
    _arquivoAssinadoFileUploaderComponent: BnFileUploaderComponent;

    @ViewChild('anexos')
    _anexosFileUploaderComponent: BnFileUploaderComponent;

    documentoTramite: any;
    anexos: Anexo[];
    assinantes: Assinatura[];
    acesso: Acesso;


    processandoAssinaturaGovBr: boolean = false;
    idTramite: number;
    nomeUsuarioExterno: string;
    saudacaoUsuarioExterno: string;
    mensagemBoasVindas: string;
    tipoSituacaoTramite: TipoSituacaoTramiteEnum;
    tipoFormatoAssinatura: TipoFormatoAssinaturaEnum;
    formulario: VisualizadorFormGroup;
    tituloDocumentoOriginal: string;
    dataDocumentoTramite: Date;
    descricaoDocumentoTramite: string;
    urlEvoSdkDownload: string;

    comMarcaDagua: boolean = true;
    semMarcaDagua: boolean = false;
    reloadAnexos: boolean = true;

    tipoAcaoAssinatura: TipoAcaoAssinaturaEnum = TipoAcaoAssinaturaEnum.Nenhuma;


    constructor(private activeRoute: ActivatedRoute,
                private cookieService: CookieService,
                protected svc: Services,
                protected fb: UntypedFormBuilder,
                protected service: VisualizadorService,
                private router: Router) {
        super();
        this.formulario = new VisualizadorFormGroup(this.fb);
        this.anexos = [];       
    }

    ehParaRecuperarDocumentosComMarcaDagua()
    {
      return this.comMarcaDagua;
    }

    public onCliqueVisualizarDocumentosComMarcaDagua()
    {
      switch(this.comMarcaDagua){
            case false:
                this.semMarcaDagua = false;
                this.comMarcaDagua = true;
                break;
            case true:
                this.semMarcaDagua = true;
                this.comMarcaDagua = false;
                break;
        }
        this.reloadAnexos = false;
        this.reload();
        this.consultarTramiteExterno();
    }

    reload(){
        setTimeout(() => {
            this.reloadAnexos = true;
        }, 100);
    }
    podeVisualizarDocumentoSemMarcaDagua()
    {
        if (this.documentoTramite &&
            this.documentoTramite.tipoAcessoExterno == TipoAcessoExternoEnum['Destinatario'] &&
            this.documentoTramite['tipoSituacaoTramite'] == TipoSituacaoTramiteEnum['Assinado'] &&
            this.documentoTramite.tipoFormatoRecebimentoDocumento == TipoFormatoRecebimentoDocumentoEnum['Original'])
             return true; else return false;
    }

    ngOnDestroy() {
        super.destroy();
        this.inicializaFileUploaderVazio();
        this.inicializaAnexosFileUploaderVazio();
        this.limparDadosSessaoParaGovBr();
    }

    ngOnInit() {
        super.init();
        const params = this.getParams();
        const code = params.code;
        const estaProcessandoAssinaturaGovBr = code != null;

        if(estaProcessandoAssinaturaGovBr)
        {
            setTimeout(()=>{this.registrarAssinaturaGovBr(code);}, 500);
            return;
        }else
        {
          //Veio da tela de autenticacao
            this.svc.logger.debug('Oriundo de Acesso Externo - autenticação');
            this.limparDadosSessaoParaGovBr();
            this.consultarTramiteExterno();
            this.verificaSituacaoTramiteDestinatario();
            this.isActivate();
            this.inicializaFileUploaderVazio();
            this.inicializaAnexosFileUploaderVazio();
        }
    }

    private registrarAssinaturaGovBr(code: string) {
        const chaveAcesso = this.svc.sessionStorageService.getChaveAcesso();
        const idTramite = +this.svc.sessionStorageService.getTramite();
        const idAssinante = +this.svc.sessionStorageService.getAssinante();
        this.processandoAssinaturaGovBr = true;

        new RegistrarAssinaturaGovBrAction(chaveAcesso,idTramite,idAssinante,code, Assinatura.criarVazio()).dispatch()
            .then(() => {
                this.processandoAssinaturaGovBr = false;
                this.limparDadosSessaoParaGovBr();
                this.consultarTramiteExterno();
                this.svc.bnAlertService.alertaSucesso('Sucesso', 'Assinatura Gov Br registrada no documento.');
            })
            .catch((error: any) => {

                this.processandoAssinaturaGovBr = false;
                this.limparDadosSessaoParaGovBr();
                new RegistrarTipoAutenticacaoAction(TipoAutenticacaoEnum.GovBR).dispatch().then((state) => {
                    this.consultarTramiteExterno('Não foi possível registrar assinatura gov.br. Feche todas as sessões do navegador e tente novamente.', error);
                });

            });
    }

    private limparDadosSessaoParaGovBr() {
        this.svc.sessionStorageService.limparDadosSessaoParaGovBr();
        this.router.navigate([],{queryParams: {'code':null}});
    }

    private inicializaFileUploaderVazio()
    {
        if (this._arquivoOriginalFileUploaderComponent)
        {
            this._arquivoOriginalFileUploaderComponent.listaEnviado = [];
            this._arquivoOriginalFileUploaderComponent.listaPendente = [];
        }

        if (this._arquivoAssinadoFileUploaderComponent)
        {
            this._arquivoAssinadoFileUploaderComponent.listaEnviado = [];
            this._arquivoAssinadoFileUploaderComponent.listaPendente = [];
        }

    }

    private inicializaAnexosFileUploaderVazio()
    {
        if (this._anexosFileUploaderComponent)
        {
            this._anexosFileUploaderComponent.listaEnviado = [];
            this._anexosFileUploaderComponent.listaPendente = [];
        }

    }

    inicializarFileUpload()
    {
        if (this._arquivoOriginalFileUploaderComponent)
        {
            this._arquivoOriginalFileUploaderComponent.listaEnviado = [];
            this._arquivoOriginalFileUploaderComponent.listaPendente = [];

            const fupArquivo = new FileUploaderArquivo();
            fupArquivo.mimeType = 'application/pdf';
            fupArquivo.id = this.documentoTramite['arquivoOriginal'].id;
            fupArquivo.nome = this.documentoTramite['arquivoOriginal'].nomeArquivo;
            fupArquivo.tamanho = this.documentoTramite['arquivoOriginal'].tamanho;
            fupArquivo.descricao = this.documentoTramite['arquivoOriginal'].descricao;

            this._arquivoOriginalFileUploaderComponent.listaEnviado.push(fupArquivo);
            this._arquivoOriginalFileUploaderComponent.url = this.getUrlArquivoOriginalComMarcaDagua();
        }

        if (this._arquivoAssinadoFileUploaderComponent)
        {
            this._arquivoAssinadoFileUploaderComponent.listaEnviado = [];
            this._arquivoAssinadoFileUploaderComponent.listaPendente = [];

            const fupArquivo = new FileUploaderArquivo();
            fupArquivo.mimeType = 'application/pdf';
            fupArquivo.id = this.documentoTramite['arquivoAssinado'].id;
            fupArquivo.nome = this.documentoTramite['arquivoAssinado'].nomeArquivo;
            fupArquivo.tamanho = this.documentoTramite['arquivoAssinado'].tamanho;
            fupArquivo.descricao = this.documentoTramite['arquivoAssinado'].descricao;

            this._arquivoAssinadoFileUploaderComponent.listaEnviado.push(fupArquivo);
            this._arquivoAssinadoFileUploaderComponent.url = this.getUrlArquivoAssinadoComMarcaDagua();
        }
    }

    inicializarAnexos(anexos: ArquivoTramite[])
    {
        if (this._anexosFileUploaderComponent)
        {
            this._anexosFileUploaderComponent.listaEnviado = [];
            this._anexosFileUploaderComponent.listaPendente = [];

            this._anexosFileUploaderComponent.url = this.getUrlArquivoAnexo(this.comMarcaDagua)

            for (let anexo of anexos)
            {
                let fupArquivo = new FileUploaderArquivo();
                fupArquivo.id = anexo['arquivo']['id'];
                fupArquivo.nome = anexo['arquivo']['nomeArquivo'];
                fupArquivo.mimeType = anexo['arquivo']['tipoConteudo'];
                fupArquivo.tamanho = anexo['arquivo']['tamanho'];
                fupArquivo.descricao = anexo['arquivo']['descricao'];

                this._anexosFileUploaderComponent.listaEnviado.push(fupArquivo);

            }
        }

    }


    onRejeitar()
    {
        let params = this.getParams();
        let justificativa = this.formulario.formGroup.get('justificativa').value;

        new RejeitarAssinaturaTramiteAction(params.chaveAcesso, params.idAssinante, justificativa).dispatch().then((state: AppState) =>
        {
            this.consultarTramiteExterno();
            this.svc.bnAlertService.alertaSucesso(`Sucesso`, `Documento rejeitado.`);
        }).catch((error: any) => {
            this.svc.bnAlertService.alertaErro(`Erro`, `Falha ao rejeitar o documento`);
        });

    }

    onChangeJustificativa()
    {
        let justificativa = this.formulario.formGroup.get('justificativa').value;
        this.justificativaPreenchida = justificativa.length > 0 ? true : false;
    }

    private getParams()
    {
        return this.activeRoute.snapshot.params;
    }

    onAssinarICPBrasil()
    {
        let componente = this;
        let idTramite = this.idTramite;
        let loadingService = this.svc.loadingService;
        let params = this.getParams();

        let callback = function (obj, obj2)
        {
            new RegistrarAssinaturaDigitalOnlineAction(params.chaveAcesso, params.idAssinante, idTramite).dispatch().then((state: AppState) =>
            {
                componente.consultarTramiteExterno();
                componente.svc.bnAlertService.alertaSucesso(`Sucesso`, `Assinatura digital registrada no documento.`);
            }).catch((error: any) =>
            {
                componente.svc.bnAlertService.alertaErro(`Erro`, `Falha ao registrar assinatura.` + error);
                componente.svc.logger.error(`[ERRO] Não foi possível registrar assinatura.`, error);
            });
        }

        let callbackError = function (msg, err)
        {
            componente.svc.bnAlertService.alertaErro('Erro', msg, err);
            loadingService.liberaTela();
        }

        try
        {
            this.service.registrarAssinaturaDigitalOnline(params.chaveAcesso, params.idAssinante, idTramite, callback, callbackError);
        }
        catch (err)
        {
            componente.svc.bnAlertService.alertaErro(`Erro`, "Não foi possível registrar assinatura." + err.msg);
            componente.svc.logger.error(`[ERRO] Não foi possível registrar assinatura.`, err.msg);
        }

    }

    onAssinarGovBr()
    {
        const params = this.getParams();
        this.svc.sessionStorageService.salvarDadosSessaoParaGovBr(params);

        this.service.obterParametrosGovBr(params.chaveAcesso, this.idTramite, params.idAssinante).subscribe((paramsGovBr: ParametroGovBr)=>{
            let href = `${paramsGovBr.urlAuthorize}?response_type=code&redirect_uri=${paramsGovBr.redirectExterno}&scope=${paramsGovBr.scope}&client_id=${paramsGovBr.clientId}`;
            window.document.location.href = href;
        },
        error=>{
            this.limparDadosSessaoParaGovBr();
            this.svc.bnAlertService.alertaErro('Erro',error.cabecalho+ ' Não foi possível registrar assinatura. Tente novamente.');
        });
    }

    confirmarAcao()
    {
        switch (this.tipoAcaoAssinatura)
        {
          case TipoAcaoAssinaturaEnum.AssinandoICPBrasil:
            this.onAssinarICPBrasil();
            break;
          case TipoAcaoAssinaturaEnum.AssinandoGOVBR:
            this.onAssinarGovBr();
            break;
          case TipoAcaoAssinaturaEnum.Rejeitando:
            this.onRejeitar();
            break;

        }
    }

    getIcone(assinatura: Assinatura)
    {
        if (assinatura.tipoSituacaoAssinatura == TipoSituacaoAssinaturaEnum['Assinada'])
        {
            return 'assets/signed.svg';
        }
        if (assinatura.tipoSituacaoAssinatura == TipoSituacaoAssinaturaEnum['Rejeitada'])
        {
            return 'assets/rejected.svg';
        }

        return 'assets/file-signature-solid.svg';

    }

    getTipoSituacaoAssinatura(assinatura: Assinatura)
    {
        return TipoSituacaoAssinaturaEnum[assinatura.tipoSituacaoAssinatura];
    }

    public get arquivoFileUploaderComponent()
    {
        return this._arquivoOriginalFileUploaderComponent;

    }

    podeConfirmarAcaoSelecionada()
    {
      if (this.tipoAcaoAssinatura == null){
        return false;
      }
      switch (this.tipoAcaoAssinatura)
      {
         case TipoAcaoAssinaturaEnum.AssinandoICPBrasil: return true;
         case TipoAcaoAssinaturaEnum.AssinandoGOVBR: return this.estaAutenticadoGovBR();
         case TipoAcaoAssinaturaEnum.Rejeitando: return true;
         default: return false;
      }
    }

    cancelarAcaoSelecionada()
    {
        this.formulario.formGroup.get('justificativa').setValue('');
        this.formulario.formGroup.get('justificativa').setValidators(null);
        this.tipoAcaoAssinatura = TipoAcaoAssinaturaEnum.Nenhuma;
    }

    onSelecionarAssinarIcpBrasil()
    {
      this.tipoAcaoAssinatura = TipoAcaoAssinaturaEnum.AssinandoICPBrasil;
    }

    onSelecionarAssinarGovBR()
    {
      this.tipoAcaoAssinatura = TipoAcaoAssinaturaEnum.AssinandoGOVBR;
    }

    onSelecionarRejeitar()
    {
        this.formulario.formGroup.get('justificativa').setValidators([Validators.required, Validators.maxLength(4000)]);
        this.tipoAcaoAssinatura = TipoAcaoAssinaturaEnum.Rejeitando;
    }

    consultarTramiteExterno(tituloErro?: string, error?: any)
    {
        const parametros = this.activeRoute.snapshot.params;
        this.tipoAcaoAssinatura = TipoAcaoAssinaturaEnum.Nenhuma;
        new ConsultarTramiteExternoAction(parametros.chaveAcesso, parametros.idAssinante).dispatch().then((state) =>
        {

            this.documentoTramite = state.documentoTramite;

            this.idTramite = this.documentoTramite['idTramite'];
            this.svc.sessionStorageService.setTramite(this.idTramite)


            this.nomeUsuarioExterno = this.documentoTramite['nomeUsuarioExterno'];
            this.assinantes = this.documentoTramite['assinantes'];
            this.tipoSituacaoTramite = this.documentoTramite['tipoSituacaoTramite'];
            this.tituloDocumentoOriginal = this.documentoTramite['titulo'];
            this.dataDocumentoTramite = new Date(this.documentoTramite['dataDocumento']);
            this.descricaoDocumentoTramite = this.documentoTramite['descricao'];
            this.tipoFormatoAssinatura = this.documentoTramite['tipoFormatoAssinatura'];

            this.formulario.formGroup.get('titulo').setValue(this.documentoTramite['titulo']);
            this.formulario.formGroup.get('dataDocumento').setValue(this.documentoTramite['dataDocumento']);
            this.formulario.formGroup.get('descricao').setValue(this.documentoTramite['descricao']);
            this.formulario.formGroup.get('situacaoTramite').setValue(TipoSituacaoTramiteEnum[this.documentoTramite['tipoSituacaoTramite']]);

            this.inicializarFileUpload();
            this.inicializarAnexos(this.documentoTramite['anexos']);

            this.desabilitaJustificativa();
            this.mensagemBoasVindas = this.montarMensagemBoasVindas();
            this.saudacaoUsuarioExterno = this.montarSaudacaoUsuarioExterno();
            this.urlEvoSdkDownload = this.documentoTramite['urlEvoSdkDownload'];

            if (error)
            {
              this.alertarErro('Erro', tituloErro, error);

            }
        }).catch((err: any) =>
        {
            if (err.hasOwnProperty('error') &&
                err.error.hasOwnProperty('mensagem') &&
                err.error.mensagem.toUpperCase().indexOf("ACESSO NEGADO") > -1) {
                return;
            }

            this.svc.bnAlertService.alertaErro(`Erro`, `Falha ao consultar trâmite externo`);
            this.svc.logger.error(`[ERRO] Falha ao consultar trâmite externo`, err);
        });

    }

    private getUrlArquivoOriginalComMarcaDagua(): string
    {
        if (!this.podeExibirDownloadArquivoOriginal())
        {
            return `#`;
        }

        let params = this.getParams();
        return `${location.origin}/smd_spa/rest/api/externo/tramite/arquivo-original/${params.chaveAcesso}/${params.idAssinante}`;

    }

    getUrlArquivoOriginalSemMarcaDagua(): string
    {
        if (!this.podeExibirDownloadArquivoOriginalSemMarcaDagua())
        {
            return `#`;
        }

        let params = this.getParams();
        return `${location.origin}/smd_spa/rest/api/externo/tramite/arquivo-original/${params.chaveAcesso}/${params.idAssinante}/conteudo-semmarca`;

    }

    private getUrlArquivoAssinadoComMarcaDagua(): string
    {
        if (!this.podeExibirDownloadArquivoAssinado())
        {
            return `#`;
        }

        let params = this.getParams();
        return `${location.origin}/smd_spa/rest/api/externo/tramite/arquivo-assinado/${params.chaveAcesso}/${params.idAssinante}`;

    }

    getUrlArquivoAssinadoSemMarcaDagua(): string
    {
        if (!this.podeExibirDownloadArquivoAssinadoSemMarcaDagua())
        {
            return `#`;
        }

        let params = this.getParams();
        return `${location.origin}/smd_spa/rest/api/externo/tramite/arquivo-assinado/${params.chaveAcesso}/${params.idAssinante}/conteudo-semmarca`;

    }

    private getUrlArquivoAnexo(comMarcaDagua: boolean): string
    {
        let params = this.getParams();
        return comMarcaDagua ?
             `${location.origin}/smd_spa/rest/api/externo/tramite/arquivo-anexo-com-marca-dagua/${params.chaveAcesso}/${params.idAssinante}` :
             `${location.origin}/smd_spa/rest/api/externo/tramite/arquivo-anexo-sem-marca-dagua/${params.chaveAcesso}/${params.idAssinante}`;


    }

    desabilitaJustificativa()
    {
        if (this.estaRejeitado())
        {
            this.formulario.formGroup.get('justificativa').disable();
        }

    }

    montarMensagemBoasVindas()
    {
        var result = "";
        if (this.documentoTramite.tipoAcessoExterno == TipoAcessoExternoEnum['Pessoa Física Externa'])
        {
            result = "Você recebeu o documento abaixo para assinar!";
        }
        else if (this.documentoTramite.tipoAcessoExterno == TipoAcessoExternoEnum['Destinatario'])
        {
            result = "Você recebeu o documento assinado abaixo!!";
        }

        if (this.estaRejeitado() || this.estaAssinadoPeloSignatario())
        {
            result = "";
        }

        return result;

    }

    estaSituacaoAssinatura(nomeAssinante:string, tipoSituacaoAssinatura:TipoSituacaoAssinaturaEnum)
    {
        let filtro = this.assinantes.filter((a:Assinatura) => a.nomeCompleto.toUpperCase() == nomeAssinante.toUpperCase() && a.tipoSituacaoAssinatura == tipoSituacaoAssinatura);
        return filtro != null && filtro.length > 0;

    }

    estaRejeitado()
    {
        if (this.documentoTramite)
        {
            return this.estaSituacaoAssinatura(this.nomeUsuarioExterno, TipoSituacaoAssinaturaEnum['Rejeitado']) || this.tipoSituacaoTramite == TipoSituacaoTramiteEnum['Rejeitado'];
        }
        return false;

    }

    estaAssinadoPeloSignatario()
    {
        if (this.assinantes)
        {
            return this.estaSituacaoAssinatura(this.nomeUsuarioExterno, TipoSituacaoAssinaturaEnum['Assinada']);
        }
        return false;

    }

    estaEncerrado(){
        return this.documentoTramite['tipoSituacaoTramite'] == TipoSituacaoTramiteEnum['Assinado'] ||
               this.documentoTramite['tipoSituacaoTramite'] == TipoSituacaoTramiteEnum['Arquivado'];

    }

    ehParaExibirBotoaDeAssinaturaGovBR(){
      return this.tipoAutenticacao == TipoAutenticacaoEnum.GovBR;
    }

    verificaSituacaoTramiteDestinatario()
    {
        if (this.documentoTramite)
        {
            if (this.documentoTramite.tipoAcessoExterno == TipoAcessoExternoEnum['Destinatario'])
            {
                if (this.documentoTramite['tipoSituacaoTramite'] == TipoSituacaoTramiteEnum['Arquivado'])
                {
                    this.formulario.formGroup.get('situacaoTramite').setValue('Assinado');
                }
            }
        }

    }

    podeVisualizarAssinarRejeitar()
    {
        let resultado = false;
        if (this.documentoTramite)
        {
            resultado = this.documentoTramite.tipoAcessoExterno == TipoAcessoExternoEnum['Pessoa Física Externa'];
        }
        return resultado;

    }

    ehColaboradorBNDES()
    {
        return this.documentoTramite && this.documentoTramite.tipoAcessoExterno == TipoAcessoExternoEnum['Pessoa Física Externa'];
    }

    estaAutenticadoGovBR(): boolean {
      if(!this.dataDocumentoTramite) return false;
      return (this.tipoAutenticacao == TipoAutenticacaoEnum.GovBR) && (this.documentoTramite.tipoFormatoAssinatura === TipoFormatoAssinaturaEnum['Assinatura Avançada - GOV.BR']);
    }

    ehTipoFormatoAssinaturaEletronicaAvancadaGovBr() : boolean {
        if(!this.dataDocumentoTramite) return false;
        if(this.documentoTramite.tipoFormatoAssinatura === TipoFormatoAssinaturaEnum['Assinatura Avançada - GOV.BR']) return true;

        return false;
    }

    ehTipoFormatoAssinaturaQualificada() : boolean {
        if(!this.documentoTramite) return false;
        if(this.documentoTramite.tipoFormatoAssinatura == TipoFormatoAssinaturaEnum['Assinatura Qualificada - ICP-Brasil']) return true;

        return false;
    }

    podeVisualizarDetalhesTramite()
    {
        let resultado = false;
        if (this.documentoTramite)
        {
            if (this.documentoTramite['tipoSituacaoTramite'] == TipoSituacaoTramiteEnum['Cancelado']
                && this.documentoTramite['tipoAcessoExterno'] == TipoAcessoExternoEnum['Pessoa Física Externa'])
            {
                resultado = false;
            }
            resultado = true;
        }
        return resultado;
    }

    podeExibirDownloadAnexos()
    {
        return this.podeVisualizarDetalhesTramite();

    }

    podeExibirDownloadArquivoOriginal()
    {
        let resultado = false;
        if (this.documentoTramite)
        {
            if (this.documentoTramite['tipoAcessoExterno'] != TipoAcessoExternoEnum['Destinatario'])
            {
                resultado = true;
            }
        }

        return this.podeVisualizarDetalhesTramite() && resultado;

    }

    podeExibirDownloadArquivoOriginalSemMarcaDagua()
    {
        let resultado = false;
        return this.podeVisualizarDetalhesTramite() && resultado;

    }

    podeExibirDownloadArquivoAssinado()
    {
        let resultado = false;
        if (this.documentoTramite)
        {
            resultado = this.estaEncerrado();
        }

        return this.podeVisualizarDetalhesTramite() && resultado;

    }

    podeExibirDownloadArquivoAssinadoSemMarcaDagua()
    {
        let resultado = false;
        if (this.documentoTramite)
        {
            if (this.documentoTramite['tipoAcessoExterno'] == TipoAcessoExternoEnum['Destinatario'])
            {
                resultado = this.documentoTramite['tipoSituacaoTramite'] == TipoSituacaoTramiteEnum['Assinado'] &&
                            this.documentoTramite['tipoFormatoRecebimentoDocumento'] == TipoFormatoRecebimentoDocumentoEnum['Original'];
            }
        }

        return this.podeVisualizarDetalhesTramite() && resultado;

    }

    isActivate()
    {
        setInterval(() =>
        {
            let params = this.getParams();
            let uri = this.cookieService.get('uri');
            if (!params.chaveAcesso.match(uri))
            {
                window.location.reload();
            }
        }, 5000);

    }

    montarSaudacaoUsuarioExterno(): string
    {
        if (this.documentoTramite)
        {
            return "Olá, " + this.formatarNomeMaiusculas(this.documentoTramite['nomeUsuarioExterno']) + "!";
        }
        return '';
    }

    formatarNomeMaiusculas(nome: string): string
    {
        let arrayNomes = nome.split(" ");
        for (var i = 0; i < arrayNomes.length; i++)
        {
            arrayNomes[i] = arrayNomes[i].charAt(0).toUpperCase() + arrayNomes[i].slice(1).toLowerCase();
        }
        return arrayNomes.join(" ");
    }

    protected alertarErro(titulo: string, cabecalho?: string, err?: any) {
      if (err instanceof ErroApp) {
          this.svc.bnAlertService.alertaErro(titulo, err.cabecalho + ' ' + cabecalho, err.listaComentarios);
          return;
      }
      if (err == null) {
          this.svc.bnAlertService.alertaErro(titulo, (cabecalho)? cabecalho : '');
          return;
      }
      this.svc.bnAlertService.alertaErro(titulo,  (cabecalho)? cabecalho : '', err);
  }
}
